import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import _typeof from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/typeof";
import "core-js/modules/es6.array.sort";
import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

var _props;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "DropdownSelect",
  props: (_props = {
    customStyle: {
      default: " q-pb-none "
    },
    neverReadOnly: {
      type: Boolean,
      default: false
    },
    optionsValue: {
      type: String
    },
    optionLabel: {
      type: String
    },
    refs: {
      type: String
    },
    rules: {
      type: Array
    },
    readOnly: {
      default: false
    },
    label: {
      type: String,
      default: null
    },
    selectOptions: null,
    outlined: {
      type: Boolean,
      default: true
    },
    filled: {
      type: Boolean
    },
    color: {
      type: String
    },
    BGColor: {
      type: String,
      default: "white"
    },
    dense: {
      type: Boolean,
      default: true
    },
    optionsDense: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String
    },
    value: null,
    inputStyle: {
      type: String,
      default: "width:100% !important;"
    },
    useInput: {
      default: false,
      type: Boolean
    },
    emitValue: {
      default: false,
      type: Boolean
    },
    mapOptions: {
      default: false,
      type: Boolean
    },
    sort: {
      default: false
    },
    initialOptionsParam: {
      default: null
    },
    allowNew: {
      default: false
    }
  }, _defineProperty(_props, "rules", {}), _defineProperty(_props, "required", {
    default: false
  }), _defineProperty(_props, "disable", {}), _defineProperty(_props, "displayValue", null), _defineProperty(_props, "compressSelectedOptions", {
    default: false,
    type: Boolean
  }), _defineProperty(_props, "optionsSelectedClass", {
    type: String
  }), _props),
  data: function data() {
    return {
      options: null,
      originalOptions: [],
      originalValue: null
    };
  },
  mounted: function mounted() {
    this.originalValue = this.value;
  },
  created: function created() {
    this.loadOptions();
  },
  methods: {
    createValue: function createValue(val, done) {
      var newObject = {};
      newObject[this.optionsValue] = 0;
      newObject[this.optionLabel] = val;
      if (done) done(newObject);
    },
    onBlur: function onBlur() {
      if (this.allowNew && !this.value) {
        var newObject = {};
        newObject[this.optionsValue] = 0;
        newObject[this.optionLabel] = this.$refs.input.inputValue;
        this.$emit("input", newObject);
      }
    },
    filterFn: function filterFn(val, update, abort) {
      var _this = this;

      update(function () {
        if (!_this.useInput) update();

        if (val) {
          var needle = val.toLowerCase();
          if (_this.optionLabel) _this.options = _this.originalOptions.filter(function (v) {
            return v[_this.optionLabel].toLowerCase().indexOf(needle) > -1;
          });else _this.options = _this.originalOptions.filter(function (v) {
            return v.label.toLowerCase().indexOf(needle) > -1;
          });
        } else {
          _this.options = _this.originalOptions;
        }

        update();
      });
    },
    validate: function validate() {
      return this.$refs.input.validate();
    },
    isRequired: function isRequired() {
      return !this.required || this.value != null && (this.multiple == false || this.value.length > 0) || "Required";
    },
    loadOptions: function loadOptions() {
      var _this2 = this;

      if (typeof this.selectOptions === "function") {
        this.selectOptions(this.initialOptionsParam).then(function (resp) {
          _this2.originalOptions = _this2.options = resp.filter(function (x) {
            return x;
          });
        });
      } else {
        this.originalOptions = this.options = this.selectOptions;
      }
    },
    resetDirty: function resetDirty() {
      this.originalValue = this.value;
    }
  },
  computed: {
    hasError: function hasError() {
      return this.$refs.input.hasError;
    },
    sortedOptions: function sortedOptions() {
      var _this3 = this;

      return this.options.sort(function (a, b) {
        var aLabel = a[_this3.optionLabel].toUpperCase();

        var bLabel = b[_this3.optionLabel].toUpperCase();

        var comparison = 0;

        if (aLabel > bLabel) {
          comparison = 1;
        } else if (aLabel < bLabel) {
          comparison = -1;
        }

        return comparison;
      });
    },
    isDirty: function isDirty() {
      if (this.originalValue == null && this.value != null) {
        return true;
      }

      if (this.originalValue && this.originalValue != null && _typeof(this.originalValue) == "object" && this.value && _typeof(this.value) == "object") {
        return this.value && this.value != "" && Object.entries(this.value).toString() != Object.entries(this.originalValue).toString();
      }

      return this.value && this.value != "" && this.value != this.originalValue;
    },
    innerValue: function innerValue() {
      return this.$refs.input.innerValue;
    }
  },
  watch: {
    selectOptions: function selectOptions() {
      this.loadOptions();
    }
  }
};